import { createQueryKeys } from "@lukemorales/query-key-factory"

export default createQueryKeys("offerLetter", {
  list: () => ({
    queryKey: ["list"],
  }),
})
